export default {
    'search-by': 'البحث عبر',
    'search-type': {
        all: 'الكل',
        city: 'المدينة',
        'medical-rep': 'المندوب',
    }
}